module.exports = __webpack_public_path__ + "img/carousel-clientes-6.6707e154.png";